import classNames from "classnames";

const BG_COLOR = {
  cancelled: "bg-[#FEE4E2]",
  rejected: "bg-[#FEE4E2]",
  approved: "bg-[#D1FADF]",
  processing: "bg-[#C7DFFC]",
  activityInProgress: "bg-[#C7DFFC]"
} as const;

const TEXT_COLOR = {
  cancelled: "text-[#B42318]",
  rejected: "text-[#B42318] capitalize",
  approved: "text-[#05603A] capitalize",
  processing: "text-[#3290FE]",
  activityInProgress: "text-[#3290FE]"
} as const;

export default function Status({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return (
    <div
      className={classNames(
        "p-1 pr-2 w-fit flex items-center rounded-lg text-xs font-medium",
        BG_COLOR[value] ?? "bg-[#C7DFFC]"
      )}
    >
      {label && (
        <div
          className={classNames(
            "bg-white mr-2 px-2 py-0.5  rounded-lg",
            TEXT_COLOR[value] ?? "text-[#3290FE]"
          )}
        >
          {label}
        </div>
      )}
      <div className={classNames(TEXT_COLOR[value] ?? "text-[#3290FE]")}>
        {value}
      </div>
    </div>
  );
}
